import { FormSignIn } from "../../components/FormSignIn";

export const SignIn = () => {
  return (
    <>
      <FormSignIn/>
    </>
  );

}